import {Spinner} from '@fluentui/react';
import {FC, useEffect, useMemo, useState} from 'react';
import {sortByTitle} from '../../../../../../helpers/arrayMehods';
import {useService} from '../../../../../../hooks';
import {Document} from '../../../../../../models';
import {EnhancedDetailsList, OtherColumn} from '../../../../../common/EnhancedDetailsList';
import {EnhancedAddButton} from '../../../../../common/EnhancedDetailsList/EnhancedAddButton';
import {SpecialColumnKey} from '../../../../../common/EnhancedDetailsList/IEnhancedDetailsList';
import {getColumnsAdd} from '../../../../../common/ProcessSections/documentAndFileColumns';
import {IProcessRowDocuments} from './IProcessRowDocuments';

function mapChangedDocumentToDocument(changedItem: Document): Document {
  return changedItem;
}

export const ProcessRowDocuments: FC<IProcessRowDocuments> = ({model, disabled}) => {
  const {getDocuments} = useService();
  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const documentsResponse = await getDocuments();
      if (!documentsResponse.result) return;
      const normalizedDocuments = documentsResponse.result
      .map(doc => ({
        ...doc,
        isFavorite: null,
      }))
      .sort(sortByTitle);
      setDocuments(normalizedDocuments);
      setIsLoading(false);
    })();
  }, [getDocuments]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [documents, setDocuments] = useState<Document[]>([]);
  const [newItemsIds, setNewItemsIds] = useState<number[]>([]);
  const columnsAdd = useMemo(
    () => [
      {
        key: SpecialColumnKey.Add,
        name: '',
        isResizable: false,
        minWidth: 90,
        maxWidth: 90,
        onRender: (item: Document) => (
          <EnhancedAddButton
            item={item}
            addedIds={newItemsIds}
            addDocument={newItem => {
              const mappedItem = newItem;
              mappedItem.active = true;
              model.changedDocuments.push(newItem);
              setNewItemsIds([...newItemsIds, newItem.id]);
            }}
            disabled={disabled}
          />
        ),
        data: OtherColumn
      },
      ...getColumnsAdd(model.changedDocuments as any)
    ],
    [newItemsIds, setNewItemsIds, disabled, model]
  );
  return isLoading ? (
    <Spinner />
  ) : (
    <EnhancedDetailsList<Document, Document, Document>
      items={documents}
      allowAdd
      isAddModal
      columns={columnsAdd}
      changedItems={model.changedDocuments}
      mapChangedItemToItem={mapChangedDocumentToDocument}
      newItemsIds={newItemsIds}
      pageSize={5}
    />
  );
};
